import {
  SubTaskDenormalized,
  SubTaskTemplate,
  SubTaskType
} from '@dadohr/shared/domainTypes/experience';
import {
  Calendar,
  CalendarPlus,
  Check,
  CheckCircle2,
  Link,
  Pencil,
  Play,
  Upload,
  Users
} from 'lucide-react';

export const SubTaskIcon = ({
  s,
  size = 16
}: {
  s: SubTaskTemplate | SubTaskDenormalized;
  size?: number;
}) => {
  switch (s.type) {
    case SubTaskType.CONFIRM:
      return <Check size={size} />;
    case SubTaskType.MEET:
      return <Users size={size} />;
    case SubTaskType.SUBMIT:
      return <Upload size={size} />;
    case SubTaskType.WATCH:
      return <Play size={size} />;
    case SubTaskType.VISIT:
      return <Link size={size} />;
    case SubTaskType.QUESTION:
      return <Pencil size={size} />;
    case SubTaskType.CALENDLY_INVITE:
      return <Calendar size={size} />;
    case SubTaskType.CREATE_MEETING:
      return <CalendarPlus size={size} />;
    default:
      return <CheckCircle2 size={size} />;
  }
};
